import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChamadoFranquiaListarRoutingModule } from './chamado-franquia-listar-routing.module';
import { ChamadoFranquiaListarComponent } from './chamado-franquia-listar.component';
import { TableModule } from 'primeng/table';
import { MessagesModule } from 'primeng/messages';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';


@NgModule({
  declarations: [
    ChamadoFranquiaListarComponent
  ],
  imports: [
    CommonModule,
    ChamadoFranquiaListarRoutingModule,
    FormsModule,
    TableModule,
    DropdownModule,
    MessagesModule,
    ButtonModule,
    InputTextModule
  ]
})
export class ChamadoFranquiaListarModule { }
